module.exports = __webpack_public_path__ + "vue/img/banner.355e360f.jpg";